import React, { useEffect, useState } from "react";
import { Table, Modal, Badge, Card } from "react-bootstrap";
import axios from "axios";
import logo from "../images/TP-_logo-orizz-claim-color.png";
import {
  FaMapMarkerAlt,
  FaCubes,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";

function BasicExample() {
  const [sortedClientiData, setSortedClientiData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "valore",
    direction: "descending",
  });
  const [showModal, setShowModal] = useState(false);
  const [selectedCliente, setSelectedCliente] = useState(null);

  // ... (fetchData e sortArray rimangono invariati)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("mancata_vendita_dashboard.json");
        if (!res.data?.TP?.localita) return;
        const clientiData = res.data.TP.localita || [];
        const lastMinuti = res.data.TP.lastminuti || [];
        const today = new Date().toISOString().split("T")[0];

        const expressMap = lastMinuti.reduce((acc, lm) => {
          if (!lm.ordinato) return acc;

          const dataOrdine = lm.data_ordine?.split(" ")[0];
          if (dataOrdine !== today) return acc;

          const key = String(lm.codice_cliente).trim(); // 👈 SOLO ID

          const valore =
            parseFloat(
              String(lm.ordinato).replace(/\./g, "").replace(",", "."),
            ) || 0;

          acc[key] = (acc[key] || 0) + valore;

          return acc;
        }, {});

        const transformedData = clientiData.reduce((acc, item) => {
          const id = item.id_cliente;
          const origine = item.origine || "web";
          const key = `${id}-${origine}`;
          const valore = parseFloat(item.Valore?.replace(",", ".")) || 0;

          if (!acc[key]) {
            acc[key] = {
              id_cliente: id,
              cliente: item.clienti,
              valore: 0,
              express: 0,
              regular: 0,
              numero: 0,
              localita: item.regione || item.nazione || item.paese,
              origine,
              dettagli: [],
            };
          }
          acc[key].valore += valore;
          acc[key].numero += Number(item.numero_doc || 0);
          acc[key].dettagli.push({
            descrizione: item.descrizione,
            valore: valore,
          });
          return acc;
        }, {});

        Object.values(transformedData).forEach((cliente) => {
          const key = String(cliente.id_cliente).trim(); // 👈 SOLO ID

          const express = expressMap[key] || 0;

          cliente.express = Math.min(express, cliente.valore);
          cliente.regular = cliente.valore - cliente.express;
        });

        setSortedClientiData(
          sortArray(
            Object.values(transformedData),
            sortConfig.key,
            sortConfig.direction,
          ),
        );
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, [sortConfig]);

  const sortArray = (array, key, direction) => {
    return [...array].sort((a, b) => {
      const aValue = a[key] ?? 0;
      const bValue = b[key] ?? 0;
      if (typeof aValue === "number")
        return direction === "ascending" ? aValue - bValue : bValue - aValue;
      return direction === "ascending"
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });
  };

  const handleSort = (key) => {
    setSortConfig({
      key,
      direction:
        sortConfig.key === key && sortConfig.direction === "ascending"
          ? "descending"
          : "ascending",
    });
  };

  const formatToEuro = (amount) =>
    new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);
  // ... (import e logica restano uguali)

  return (
    <>
      <Card
        className="card ombra ordini-ora card-home hover-effect border-0"
        style={{ borderRadius: "15px", padding: "1.2rem", paddingBottom: "0" }}
      >
        <div
          className="no-scrollbar"
          style={{
            width: "100%",
            height: 300,
            overflowY: "auto",
            overflowX: "auto", // ABILITA LO SCROLL ORIZZONTALE
            position: "relative",
            scrollbarWidth: "thin", // Per Firefox
          }}
        >
          <Table
            hover
            className="mb-0 custom-table"
            style={{
              fontSize: "0.75rem",
              width: "100%",
              minWidth: "700px", // FORZA LA LARGHEZZA MINIMA PER EVITARE COLLASSI
              margin: 0,
              borderCollapse: "separate",
            }}
          >
            <thead className="sticky-top bg-white" style={{ zIndex: 10 }}>
              <tr
                className="text-muted small"
                style={{ borderBottom: "2px solid #f1f1f1" }}
              >
                <th style={{ width: "25%" }} className="ps-4 py-3 border-0">
                  CLIENTE
                </th>
                <th
                  style={{ width: "15%" }}
                  className="py-3 border-0 cursor-pointer"
                  onClick={() => handleSort("localita")}
                >
                  LOCALITÀ
                </th>
                <th
                  style={{ width: "15%" }}
                  className="py-3 border-0 text-end cursor-pointer"
                  onClick={() => handleSort("valore")}
                >
                  VALORE
                </th>
                <th
                  style={{ width: "15%" }}
                  className="py-3 border-0 text-end text-danger"
                >
                  LAST MINUTE
                </th>
                <th
                  style={{ width: "12%" }}
                  className="py-3 border-0 text-end text-secondary"
                >
                  REGULAR
                </th>
                <th
                  style={{ width: "8%" }}
                  className="py-3 border-0 text-center"
                >
                  ORDINI
                </th>
                <th
                  style={{ width: "10%" }}
                  className="py-3 border-0 text-center pe-4"
                >
                  ORIGINE
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedClientiData.map((item, index) => (
                <tr
                  key={index}
                  onClick={() => {
                    setSelectedCliente(item);
                    setShowModal(true);
                  }}
                  className="cursor-pointer align-middle"
                >
                  <td className="ps-4 fw-bold text-dark truncate-cell">
                    {item.cliente}
                  </td>
                  <td
                    className="text-muted truncate-cell"
                    style={{ fontSize: "0.7rem" }}
                  >
                    {item.localita}
                  </td>
                  <td className="text-end fw-bold text-dark no-wrap">
                    {formatToEuro(item.valore)}
                  </td>
                  <td className="text-end text-danger fw-bold no-wrap">
                    {formatToEuro(item.express)}
                  </td>
                  <td
                    className="text-end text-secondary no-wrap"
                    style={{ fontSize: "0.65rem" }}
                  >
                    {formatToEuro(item.regular)}
                  </td>
                  <td className="text-center">
                    <span className="text-dark">{item.numero}</span>
                  </td>
                  <td className="text-center pe-4">
                    <Badge
                      pill
                      className={
                        item.origine === "web"
                          ? "bg-danger-subtle text-danger"
                          : "bg-secondary-subtle text-secondary"
                      }
                      style={{ fontSize: "0.6rem" }}
                    >
                      {item.origine.toUpperCase()}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* ... (Modal resta invariata) ... */}

        <style>{`
        .custom-table {
            /* table-layout: fixed; <-- RIMOSSO per permettere alle colonne di respirare nello scroll */
            width: 100% !important;
            margin: 0 !important;
        }
        .truncate-cell {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 150px; /* Evita che il nome cliente allunghi troppo la tabella */
        }
        .no-wrap {
            white-space: nowrap; /* Impedisce ai prezzi di andare a capo */
        }
        .cursor-pointer { cursor: pointer; }
        .text-title { color: #2c3e50; }
        .fw-800 { font-weight: 800; }
        tbody tr:hover { background-color: #fbfbfb !important; }
        .sticky-top { top: -1px; background: white !important; box-shadow: 0 2px 2px -1px rgba(0,0,0,0.05); }
        
        /* SCROLLBAR STYLE */
        ::-webkit-scrollbar { height: 6px; width: 4px; }
        ::-webkit-scrollbar-thumb { background: #e0e0e0; border-radius: 10px; }
        
        .bg-primary-subtle { background-color: #e3f2fd; }
        .bg-secondary-subtle { background-color: #f5f5f5; }
        .ombra { max-width: 100%; }
      `}</style>
      </Card>

      <Modal
        show={showModal}
        className="modale-dettaglio-root"
        dialogClassName="modale-dettaglio-dialog"
        onHide={() => setShowModal(false)}
        centered
        size="sm"
        backdrop={true}
      >
        {/* Header con sfondo leggermente più chiaro per staccare dal corpo */}
        <Modal.Header closeButton className="border-0  pb-3 pt-4 px-4">
          <Modal.Title className="d-flex align-items-center w-100">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center me-3 shadow-sm"
              style={{
                width: "45px",
                height: "45px",
                border: "1px solid rgba(0, 0, 0, 0.3)",
              }}
            >
              <FaCubes size={22} style={{ color: "rgb(48, 48, 48)" }} />
            </div>
            <div className="overflow-hidden">
              <div
                style={{
                  fontSize: "1.25rem",
                  fontWeight: "800",
                  letterSpacing: "-0.5px",
                  lineHeight: "1.2",
                }}
              >
                {selectedCliente?.cliente}
              </div>
              <div
                className="text-muted fw-medium d-flex align-items-center mt-1"
                style={{ fontSize: "0.85rem" }}
              >
                <FaMapMarkerAlt className="me-1 text-danger" />{" "}
                <span>{selectedCliente?.localita}</span>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="px-4 pb-4 pt-0">
          {/* Badge stilizzati meglio */}
          <div className="mb-4 d-flex gap-2">
            <Badge
              bg="secondary"
              className="bg-opacity-25 text-dark fw-normal border border-secondary"
              style={{ fontSize: "0.7rem", padding: "5px 10px" }}
            >
              ID: {selectedCliente?.id_cliente}
            </Badge>
            <Badge
              pill
              className={
                selectedCliente?.origine === "web"
                  ? "bg-info bg-opacity-10 text-info border border-info"
                  : "bg-warning bg-opacity-10 text-warning border border-warning"
              }
              style={{ fontSize: "0.7rem", padding: "5px 10px" }}
            >
              {selectedCliente?.origine?.toUpperCase()}
            </Badge>
          </div>

          {/* Tabella con font più grandi e spaziatura migliorata */}
          <div className="d-flex justify-content-center">
            <div
              className="rounded-3 border-0 overflow-hidden"
              style={{ width: "100%" }} // Grigio quasi nero per profondità
            >
              <Table hover className="mb-0">
                <thead>
                  <tr>
                    <th
                      className="ps-3 py-3  text-uppercase"
                      style={{
                        fontSize: "0.7rem",
                        color: "#353535",
                        letterSpacing: "1px",
                      }}
                    >
                      Brand
                    </th>
                    <th
                      className="text-end pe-3  py-3 text-uppercase"
                      style={{
                        fontSize: "0.7rem",
                        color: "#353535",
                        letterSpacing: "1px",
                      }}
                    >
                      Valore
                    </th>
                  </tr>
                </thead>
                <tbody style={{ borderTop: "1px solid #333" }}>
                  {selectedCliente?.dettagli.map((d, i) => (
                    <tr
                      key={i}
                      className="align-middle"
                      style={{ borderBottom: "1px solid #e4e4e4" }}
                    >
                      <td
                        className="ps-3 py-3  fw-medium border-0"
                        style={{ fontSize: "0.95rem" }}
                      >
                        {d.descrizione || "Generico"}
                      </td>
                      <td
                        className="text-end pe-3  py-3 fw-bold border-0"
                        style={{ fontSize: "1rem" }}
                      >
                        {formatToEuro(d.valore)}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td
                      className="ps-3 py-3  border-0 fw-bold"
                      style={{ fontSize: "0.9rem" }}
                    >
                      TOTALE
                    </td>
                    <td
                      className="text-end pe-3 text-title py-3 border-0 fw-800"
                      style={{ fontSize: "1.1rem" }}
                    >
                      {formatToEuro(selectedCliente?.valore)}
                    </td>
                  </tr>
                </tfoot>
              </Table>
            </div>
          </div>
        </Modal.Body>

        {/* Aggiunta CSS per il tasto chiusura che spesso sparisce nel dark */}
        <style>{`
    .modale-dettaglio-root .btn-close {
        filter: invert(1) grayscale(100%) brightness(200%);
        opacity: 0.8;
    }
    .fw-800 { font-weight: 800; }
  `}</style>
      </Modal>
    </>
  );
}

export default BasicExample;
